import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DomUtils } from '../../utils/dom-utils';
import { CustomTooltip, InlinePopper } from '../Poppers';
import Tag from './Tag';
import { TagVariants } from './tag-consts';
import * as S from './styled';

const TEST_ID = 'multi-chips';
const MORE_LENGTH = 5;
const POPPER_SX = { maxHeight: '400px', overflowY: 'auto', maxWidth: '300px' };

export const TagsContainer = ({
  chips,
  count = 1,
  className,
  variant: defaultVariant,
  testId = TEST_ID,
  moreLength = MORE_LENGTH,
  tooltipPlacement = 'auto',
  regularTooltip = false
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { elementRef, theme } = DomUtils.useDetectParentTheme();
  if (!Array.isArray(chips)) return chips;
  const showPopper = e => setAnchorEl(e.currentTarget);
  const hidePopper = () => setAnchorEl(null);
  const more = chips.length - count;
  const variant = defaultVariant || chips[0]?.props?.variant || TagVariants.CHIP;

  const tagsContent = (
    <S.TagsContainer $tooltip>
      {chips.slice(count, count + moreLength)}
      {chips.length > count + moreLength && (
        <Tag content={`  ...  + ${chips.length - (count + moreLength)} `} variant={variant} />
      )}
    </S.TagsContainer>
  );

  return (
    <S.TagsContainer className={className} ref={regularTooltip ? elementRef : null} data-testid={testId}>
      {chips.slice(0, count)}
      {more > 0 &&
        (regularTooltip ? (
          <CustomTooltip title={tagsContent} mode={theme}>
            <div>
              <Tag className="tag-more" content={`+ ${more}`} testId={`tag-more-${testId}`} variant={variant} />
            </div>
          </CustomTooltip>
        ) : (
          <span onMouseLeave={hidePopper}>
            <Tag
              className="tag-more"
              content={`+ ${more}`}
              onMouseEnter={showPopper}
              testId={`tag-more-${testId}`}
              variant={variant}
            />
            <InlinePopper placement={tooltipPlacement} open={!!anchorEl} anchorEl={anchorEl} sx={POPPER_SX}>
              {tagsContent}
            </InlinePopper>
          </span>
        ))}
    </S.TagsContainer>
  );
};

TagsContainer.propTypes = {
  chips: PropTypes.arrayOf(PropTypes.node),
  variant: PropTypes.oneOf(['CHIP', 'MAIN', 'PRIMARY', 'NAKED']),
  count: PropTypes.number,
  className: PropTypes.string,
  regularTooltip: PropTypes.bool,
  tooltipPlacement: PropTypes.oneOf([
    'auto',
    'auto-start',
    'auto-end',
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top'
  ]),
  moreLength: PropTypes.number,
  testId: PropTypes.string
};
